import { inject, Injectable, WritableSignal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SigninSubmitRequest } from 'sham-components/shared/models/auth';
import { SigninApi } from './signin-api';
import { AuthService } from './auth.service';
import { SigninManager } from 'sham-components/shared/auth';
import notify from 'devextreme/ui/notify';
import { TranslateService } from '@ngx-translate/core';
// Trigger re-eval

@Injectable()
export class SuperAdminSigninManager extends SigninManager {
  private readonly signinApiLocal = inject(SigninApi);
  private readonly authService = inject(AuthService);
  private readonly translate = inject(TranslateService);

  override async submitForm(
    payload: SigninSubmitRequest,
    submitError: WritableSignal<string | null>,
    loading: WritableSignal<boolean>,
  ) {
    try {
      const result = await firstValueFrom(this.signinApiLocal.login(payload));

      if (!result || !result.accessToken) {
        this.authService.logout();
        submitError.set(this.translate.instant('dashboardLogin.failed'));
        return;
      }

      if (
        !Array.isArray(result.user?.roles) ||
        !result.user.roles.includes('Admin')
      ) {
        this.authService.logout();
        submitError.set(
          this.translate.instant(
            "You don't have enough permissions to access this dashboard.",
          ),
        );
        notify(
          this.translate.instant(
            "You don't have enough permissions to access this dashboard.",
          ),
          'error',
          5000,
        );
        return;
      }

      // Save logic (tokens, user, etc.)
      this.authService.saveLogin(result, payload.rememberMe);

      // Redirection logic
      this.authService.handleLoginRedirection();
    } catch (error: unknown) {
      this.authService.logout();
      const status =
        typeof error === 'object' && error && 'status' in error
          ? error.status
          : undefined;
      submitError.set(
        this.translate.instant(
          status === 401
            ? 'dashboardLogin.invalidCredentials'
            : 'dashboardLogin.error',
        ),
      );
    } finally {
      loading.set(false);
    }
  }
}
